import Yup from 'yup/yup-extensions'

import { RegexService } from 'common/services/regexService'

import { SettingsMailboxLabels } from 'features/Profile/features/Payment/constants/constants'

export const mailboxSchema = Yup.object().shape({
  // applicant
  applicant_initials: Yup.string()
    .required()
    .max(3)
    .label(SettingsMailboxLabels.initials)
    .nullable()
    .matches(RegexService.onlyLatin(), 'Please enter valid initials'),
  applicant_home_address: Yup.string()
    .required()
    .nullable()
    .max(40)
    .label(SettingsMailboxLabels.address),
  applicant_home_city: Yup.string()
    .required()
    .max(40)
    .nullable()
    .matches(RegexService.onlyLatin(), 'Please enter a valid city')
    .label(SettingsMailboxLabels.city),
  applicant_home_state: Yup.string().nullable().required().label(SettingsMailboxLabels.state),
  applicant_home_zip: Yup.string()
    .required()
    .nullable()
    .matches(RegexService.postalCode(), 'Please enter valid postal code')
    .label(SettingsMailboxLabels.postalCode),
  applicant_home_phone_number: Yup.string()
    .nullable()
    .required()
    .phone()
    .label(SettingsMailboxLabels.homePhone),

  // business
  business_name: Yup.string().required().nullable().max(40).label(SettingsMailboxLabels.firmName),
  business_address: Yup.string().required().max(40).label(SettingsMailboxLabels.address),
  business_city: Yup.string()
    .required()
    .max(40)
    .matches(RegexService.onlyLatin(), 'Please enter a valid city')
    .label(SettingsMailboxLabels.city),
  business_state: Yup.string().nullable().required().label(SettingsMailboxLabels.state),
  business_zip: Yup.string()
    .required()
    .nullable()
    .matches(RegexService.postalCode(), 'Please enter valid postal code')
    .label(SettingsMailboxLabels.postalCode),
  business_phone_number: Yup.string()
    .nullable()
    .required()
    .phone()
    .label(SettingsMailboxLabels.businessPhone),
  business_type: Yup.string()
    .nullable()
    .required()
    .max(40)
    .label(SettingsMailboxLabels.businessType),
  is_forward_mailbox: Yup.boolean(),

  forwarding_address: Yup.string()
    .nullable()
    .when('is_forward_mailbox', {
      is: true,
      then: (schema) => schema.required().max(40).label(SettingsMailboxLabels.address),
    }),
  forwarding_city: Yup.string()
    .nullable()
    .when('is_forward_mailbox', {
      is: true,
      then: (schema) =>
        schema
          .required()
          .max(40)
          .matches(RegexService.onlyLatin(), 'Please enter a valid city')
          .label(SettingsMailboxLabels.city),
    }),
  forwarding_state: Yup.string()
    .nullable()
    .when('is_forward_mailbox', {
      is: true,
      then: (schema) => schema.required().label(SettingsMailboxLabels.state),
    }),
  forwarding_zip: Yup.string()
    .nullable()
    .when('is_forward_mailbox', {
      is: true,
      then: (schema) =>
        schema
          .required()
          .matches(RegexService.postalCode(), 'Please enter valid postal code')
          .label(SettingsMailboxLabels.postalCode),
    }),
  forwarding_phone_number: Yup.string()
    .nullable()
    .when('is_forward_mailbox', {
      is: true,
      then: (schema) => schema.required().phone().label(SettingsMailboxLabels.forwardingPhone),
    }),
})
